<template>
  <div ref="markerContainer" class="map-custom-marker">
    <div class="label">
      <!-- <i :class="['iconfont', icon]"></i> -->
      <span class="label-content">{{ title }}</span>
    </div>

    <div class="marker" :class="[marker, `state-${state}`]">
      <div class="wave pos-center" v-if="marker === 'wave'"></div>

      <div class="dottle-circle pos-center" v-if="marker === 'dotted-circle'"></div>

      <div class="point pos-center">
        <i :class="['iconfont', icon]"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { useNotMovedClick } from '@/utils/dom/event';
import { mapState } from 'vuex';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    nodeId: {
      type: [Number, String],
      default: ''
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    state: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('socket', ['deviceIdMap']),
    node() {
      return this.deviceIdMap[this.nodeId] || {};
    },
    icon() {
      const dict = {
        1: 'icon-hospital',
        2: 'icon-school',
        3: 'icon-public-place',
        4: 'icon-traffic',
        5: 'icon-high-traffic'
      };

      return dict[this.node?.rteaoNodeType] || '';
    },
    marker() {
      const dict = {
        0: 'dotted-circle',
        1: 'wave',
        2: 'point'
      };

      return dict[this.node?.rteaoNodeState];
    }
  },
  methods: {},
  mounted() {
    this.$nextTick(() => {
      useNotMovedClick(this.$refs.markerContainer, () => {
        this.onClick();
      });
    });
  }
};
</script>

<style lang="scss">
.map-custom-marker {
  --marker-size: calc(var(--base-font-size) * 4.3);

  // position: absolute;
  // left: 0;
  // bottom: 10px;
  // transform: translateY(50%);

  // opacity: 0.8;

  width: max-content;

  display: flex;
  flex-direction: column;
  align-items: center;

  @keyframes blink {
    0% {
      opacity: 0.8;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 0.8;
    }
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes wave {
    0% {
      width: calc(var(--marker-size) * 0.5);
      height: calc(var(--marker-size) * 0.5);
      opacity: 0.95;
    }

    70% {
      opacity: 0.6;
    }

    85% {
      width: calc(var(--marker-size) * 0.9);
      height: calc(var(--marker-size) * 0.9);

      opacity: 0.2;
    }

    100% {
      width: calc(var(--marker-size) * 0.9);
      height: calc(var(--marker-size) * 0.9);

      opacity: 0;
    }
  }

  .pos-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .marker {
    width: var(--marker-size);
    height: var(--marker-size);
    border-radius: 50%;

    position: relative;
    z-index: -1;

    --color: grey;

    &.state-0 {
      --color: green;
    }

    &.state-1 {
      --color: orange;
    }

    &.state-2 {
      --color: yellow;
    }

    .point {
      width: calc(var(--marker-size) * 0.5);
      height: calc(var(--marker-size) * 0.5);

      border-radius: 50%;

      background: var(--color);
      box-shadow: 0 0 2px 2px grey;
      filter: drop-shadow(0 0 2px black);

      display: flex;
      justify-content: center;
      align-items: center;

      .iconfont {
        font-size: calc(var(--base-font-size) * 1.3);
      }
    }

    .wave {
      background: var(--color);
      border-radius: 50%;

      animation: wave 1.5s infinite;
    }

    .dottle-circle {
      width: calc(var(--marker-size) * 0.8);
      height: calc(var(--marker-size) * 0.8);

      border: 2px dashed var(--color);

      box-sizing: border-box;
      border-radius: 50%;

      animation: rotate 60s linear infinite;
    }
  }

  /* 设备标签基础定位 */
  .label {
    position: relative;
    cursor: pointer;

    &:hover {
      .tag-content {
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
        transform: translateY(-2px);
        transition: all 0.2s ease;
        background-color: #0c6ba8; /* 悬停时主色提亮 */

        &::after {
          border-color: #0c6ba8 transparent transparent;
          transition: all 0.2s ease;
        }
      }
    }

    /* 标签内容区域（深蓝色主题适配） */
    .label-content {
      background-color: #0a5b98; /* 主色作为标签背景 */
      border: 1px solid #1072c2; /* 主色的亮色变体作为边框 */
      border-radius: 4px;
      padding: 3px 10px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); /* 适度阴影增强层次 */
      font-family: 'Microsoft YaHei', sans-serif;
      font-size: calc(var(--base-font-size) * 1.4);
      color: #f0f7ff; /* 浅色文本确保可读性 */
      white-space: nowrap;

      &::before {
        content: '';
        position: absolute;
        bottom: -11px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 11px 9px 0;
        border-style: solid;
        border-color: #1072c2 transparent transparent; /* 与边框颜色一致 */
        z-index: -1;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 10px 8px 0;
        border-style: solid;
        border-color: #0a5b98 transparent transparent; /* 与标签背景一致 */
      }
    }
  }

  .icon-hospital {
    position: relative;

    &::before {
      position: relative;
      z-index: 2;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 85%;
      height: 85%;
      background: red;
      display: inline-block;
      border-radius: 50%;
    }
  }
}
</style>
